import { render, staticRenderFns } from "./Enviados.vue?vue&type=template&id=7dead5ae&lang=pug&"
import script from "./Enviados.vue?vue&type=script&lang=js&"
export * from "./Enviados.vue?vue&type=script&lang=js&"
import style0 from "./Enviados.vue?vue&type=style&index=0&id=7dead5ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports